import Modal from "./Modal";

import RetailerEditor from "../editors/RetailerEditor";

const RetailerModal = ({ retailerId, open, onClose, onSave }) => {
  return (
    <Modal
      title={retailerId ? "retailer_update" : "retailer_new"}
      open={open}
      onClose={onClose}
    >
      <RetailerEditor onSave={onSave} />
    </Modal>
  );
};

export default RetailerModal;
